import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import * as Tracking from '../../../utils/tracking';

export function trackOpenPhones(offer: IOfferSchema, agent: IAgentSchema | null, kpId: number | null, isBot?: boolean) {
  if (!agent) {
    return;
  }

  ca('eventSite', {
    action: `Open_deal_conditions${isBot ? '_bot' : ''}`,
    category: 'Phones',
    label: Tracking.getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [
      {
        id: offer.cianId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}
